module.exports = require("core-js-pure/features/get-iterator-method");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/get-iterator-method.js
// module id = 8Qmx
// module chunks = 0